import {
  Box,
  Container,
  Grid,
  Icon,
  IconButton,
  Link,
  List,
  ListItem,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";

import FooterLogo from "../assets/logo.png";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import snapChat from "../assets/snapchat.png";
import YouTubeIcon from "@mui/icons-material/YouTube";
import XIcon from "@mui/icons-material/X";
import CallIcon from "@mui/icons-material/Call";

const Footer = () => {
  const lang = useSelector((state) => state.global.language);
  return (
    <Container
      maxWidth="xl"
      sx={{
        flexGrow: 1,
        "& h6": {
          position: "relative",
          "&::after": {
            content: '""',
            position: "absolute",
            left: lang === "en" ? 0 : "92%",
            bottom: "-4px",
            width: "8%",
            background: "#c39d3c",
            height: "6px",
            borderRadius: "100px",
          },
          "&::before": {
            content: '""',
            position: "absolute",
            left: lang === "en" ? "-.5rem" : "67%",
            bottom: "-2px",
            width: "35%",
            background: "#c39d3c",
            height: "1px",
            borderRadius: "100px",
          },
        },
      }}
    >
      <Grid container spacing={6} mt={2}>
        <Grid item xs={12} md={4}>
          <Stack direction="column">
            <Box sx={{ maxWidth: "120px", marginBottom: "2rem" }}>
              <img src={FooterLogo} width="100%" alt="Fazaa used cars" />
            </Box>
            <Box>
              <Typography variant="body2" textAlign="justify">
                <FormattedMessage id="app.footer.about" />
              </Typography>
            </Box>
          </Stack>
        </Grid>
        <Grid item xs={12} md={4}>
          <Stack direction="column" spacing={1}>
            <Typography variant="h6">
              <FormattedMessage id="app.footer.importantLinks.title" />
            </Typography>
            <List>
              <ListItem>
                <Link
                  href={"https://rentacar.fazaa.ae/"}
                  color={"secondary.main"}
                  underline="hover"
                  target="_blank"
                >
                  <FormattedMessage id="app.footer.importantLinks.dailyRent" />
                </Link>
              </ListItem>
              <ListItem>
                <Link
                  href={"https://longtermcars.fazaa.ae/"}
                  underline="hover"
                  color={"secondary.main"}
                  target="_blank"
                >
                  <FormattedMessage id="app.footer.importantLinks.longTermLease" />
                </Link>
              </ListItem>
              <ListItem>
                <Link
                  href={"https://www.fazaa.ae/page/privacy"}
                  underline="hover"
                  color={"secondary.main"}
                  target="_blank"
                >
                  <FormattedMessage id="app.footer.importantLinks.policy" />
                </Link>
              </ListItem>
              <ListItem>
                <Link
                  href={"https://www.fazaa.ae/page/terms-and-conditions"}
                  underline="hover"
                  color={"secondary.main"}
                  target="_blank"
                >
                  <FormattedMessage id="app.footer.importantLinks.tnc" />
                </Link>
              </ListItem>
            </List>
          </Stack>
        </Grid>
        <Grid item xs={12} md={4}>
          <Stack direction="column" spacing={2}>
            <Stack direction="column" spacing={1}>
              <Typography variant="h6">
                <FormattedMessage id="app.footer.contact.title" />
              </Typography>
              <List>
                <ListItem>
                  <Stack direction={"row"} spacing={1} useFlexGap>
                    <Icon color="secondary">
                      <CallIcon />
                    </Icon>
                    <Typography variant="body1" color={"secondary"}>
                      600520003
                    </Typography>
                  </Stack>
                </ListItem>
                <ListItem>
                  <Link
                    underline="hover"
                    href="https://api.whatsapp.com/send/?phone=971526004003&type=phone_number&app_absent=0"
                    target="_blank"
                  >
                    <Stack direction={"row"} spacing={1} useFlexGap>
                      <Icon color="secondary">
                        <WhatsAppIcon />
                      </Icon>
                      <Typography variant="body1" color={"secondary"}>
                        0526004003
                      </Typography>
                    </Stack>
                  </Link>
                </ListItem>
              </List>
            </Stack>
            <Stack direction="column" spacing={1} useFlexGap>
              <Typography variant="h6">
                <FormattedMessage id="app.footer.follow.title" />
              </Typography>
              <Stack direction="row" spacing={1} useFlexGap>
                <IconButton
                  color="secondary"
                  size="medium"
                  onClick={() =>
                    window.open(
                      "https://www.instagram.com/fazaa4all/",
                      "_blank"
                    )
                  }
                >
                  <InstagramIcon sx={{ fontSize: "24px" }} />
                </IconButton>
                <IconButton
                  color="secondary"
                  size="medium"
                  onClick={() =>
                    window.open(
                      "https://www.snapchat.com/add/fazaa4all/QNg5T",
                      "_blank"
                    )
                  }
                >
                  <img src={snapChat} alt="fazaa snapchat" width={"24px"} />
                </IconButton>
                <IconButton
                  color="secondary"
                  size="medium"
                  onClick={() =>
                    window.open("https://www.facebook.com/fazaa4all", "_blank")
                  }
                >
                  <FacebookIcon sx={{ fontSize: "24px" }} />
                </IconButton>
                <IconButton
                  color="secondary"
                  size="medium"
                  onClick={() =>
                    window.open("https://x.com/fazaa4all", "_blank")
                  }
                >
                  <XIcon sx={{ fontSize: "24px" }} />
                </IconButton>

                <IconButton
                  color="secondary"
                  size="medium"
                  onClick={() =>
                    window.open(
                      "https://www.youtube.com/channel/UCDzg51SeyyD7QhVx_cY-nSw",
                      "_blank"
                    )
                  }
                >
                  <YouTubeIcon />
                </IconButton>
                {/* <IconButton
                  color="secondary"
                  size="medium"
                  onClick={() => window.open(
                    "https://www.linkedin.com/company/fazaa/",
                    "_blank"
                  )}
                >
                  <LinkedInIcon sx={{ fontSize: "24px" }} />
                </IconButton> */}
                {/* <IconButton
                  color="secondary"
                  size="medium"
                  onClick={() =>
                    window.open(
                      "https://api.whatsapp.com/send/?phone=9710526000920&type=phone_number&app_absent=0",
                      "_blank"
                    )
                  }
                >
                  <WhatsAppIcon sx={{ fontSize: "24px" }} />
                </IconButton> */}
              </Stack>
            </Stack>
          </Stack>
        </Grid>
        <Grid item xs={12} display="flex" justifyContent="center">
          <Typography variant="body1">
            <FormattedMessage id="app.footer.copyright.title" />
          </Typography>
        </Grid>
      </Grid>
    </Container>
  );
};

export default Footer;
